namespace GeniuzPOS.Lookups {
    export namespace SysCountryService {
        export const baseUrl = 'Lookups/SysCountry';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SysCountryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SysCountryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/SysCountry/Retrieve",
            List = "Lookups/SysCountry/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SysCountryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
